import { numExponentialFormat, numFormatConversion, scaleConversion } from '../../../helper/numberHelper';
import NP from 'number-precision';
import { checkSweepValue } from '../../../helper/valueCheck';
import { ROCKY } from '@/constants/pageType';
import { valueUnitSplit } from '../../../helper/valueUnitSplit';
import { PACKAGE, CARD, VERIFICATION, MULTIPLE_CHANNEL } from '../../../../constants/treeConstants';
import RockyChannels from '../channels';
import RockySetup from '@/services/Rocky/helper/rockyDatabase';
import { getVerificationContentPromise } from '../../rockyCtrl';

function extractionConversionData(extractionConfig, noDistinctionByteCA) {
  let config = JSON.parse(JSON.stringify(extractionConfig))
  const { logSweepMin, logSweepMax, linearSweepMax, linearSweepFreqStep, maxFreq, backdrillStubSize,
    caLogSweepMin, caLogSweepMax, caLinearSweepMax, caLinearSweepFreqStep, caMaxFreq, clipSize } = config;

  config.logSweepMin = numFormatConversion(logSweepMin) || "1000";
  config.logSweepMax = numFormatConversion(logSweepMax, -6) || "10";
  config.linearSweepMax = numFormatConversion(linearSweepMax, -9) || "5";
  config.linearSweepFreqStep = numFormatConversion(linearSweepFreqStep, -6) || "5";
  config.maxFreq = numFormatConversion(maxFreq, -9) || "";

  if (clipSize && clipSize.toString().includes('mm')) {
    config.clipSize = parseFloat(clipSize).toString();
  }
  if (backdrillStubSize) {
    config.backdrillStubSize = valueUnitSplit(backdrillStubSize).value || "8";
  }

  if (!noDistinctionByteCA) {
    config.caLogSweepMin = numFormatConversion(caLogSweepMin) || "1000";
    config.caLogSweepMax = numFormatConversion(caLogSweepMax, -6) || "10";
    config.caLinearSweepMax = numFormatConversion(caLinearSweepMax, -9) || "5";
    config.caLinearSweepFreqStep = numFormatConversion(caLinearSweepFreqStep, -6) || "5";
    config.caMaxFreq = numFormatConversion(caMaxFreq, -9) || "";
  }
  return config;
}

function extractionReturnData({ extractionConfig, noDistinctionByteCA, byteUnit, caUnit, clipSizeUnit, FMAXUnit, hpcOptionSwitch, isNotDisplayPowerSi, pageType, channelType }) {
  let units = noDistinctionByteCA ? ["logSweepMin", "logSweepMax", "maxFreq", "linearSweepMax", "linearSweepFreqStep"] : ["logSweepMin", "logSweepMax", "maxFreq", "linearSweepMax", "linearSweepFreqStep",
    "caLogSweepMin", "caLogSweepMax", "caMaxFreq", "caLinearSweepMax", "caLinearSweepFreqStep"]

  let config = JSON.parse(JSON.stringify(extractionConfig))
  units.forEach(item => {
    const unit = `${item}Unit`;
    const scale = scaleConversion("Hz", byteUnit[unit] ? byteUnit[unit] : caUnit[unit]);
    config[item] = config[item] ? NP.times(config[item], scale).toString() : config[item];
    config[item] = config[item] ? numExponentialFormat(config[item]) : '';
  })

  const errorMsg = checkSweepValue({
    logSweepMin: config["logSweepMin"],
    logSweepMax: config["logSweepMax"],
    linearSweepMax: config["linearSweepMax"],
    maxFreq: config["maxFreq"],
    version: ROCKY
  });
  if (errorMsg) { return { errorMsg } }

  if (!noDistinctionByteCA) {
    const _errorMsg = checkSweepValue({
      logSweepMin: config["caLogSweepMin"],
      logSweepMax: config["caLogSweepMax"],
      linearSweepMax: config["caLinearSweepMax"],
      maxFreq: config["caMaxFreq"],
      version: ROCKY
    });

    if (_errorMsg) { return { errorMsg } }
  }
  config.clipSize = clipSizeUnit === 'mm' ? `${config.clipSize}${clipSizeUnit}` : config.clipSize;

  if (pageType !== [PACKAGE, CARD].includes(pageType)) {
    config.backdrillStubSize = config.backdrillStubSize ? `${config.backdrillStubSize}mil` : "8mil";
  }

  if (!hpcOptionSwitch) {
    delete config.hpc_options;
  }

  if (!isNotDisplayPowerSi && config.FMAX) {
    config.FMAX = FMaxFormat(config.FMAX, FMAXUnit)
  }

  return { config }
}


function FMaxFormat(fMax, unit) {
  //update fMax by unit
  // "MHz" / "GHz" ==> "Hz"
  const scale = scaleConversion("Hz", unit);
  const _fMax = fMax ? NP.times(fMax, scale).toString() : fMax;
  const _format = numExponentialFormat(_fMax)
  return _format ? _format : 0;
}

function getClipSizeUnit(extractionConfig) {
  return extractionConfig && extractionConfig.clipSize && extractionConfig.clipSize.toString().includes('mm') ? "mm" : "ratio"
}

function getCurrentInterfaceInfo(rockyInfo, pcbChannelInfo, contentType, multilpleChannelId) {
  if (contentType === MULTIPLE_CHANNEL && multilpleChannelId) {
    const multiChannelInfo = RockyChannels.get(multilpleChannelId) || {};
    return multiChannelInfo;
  }

  if (!rockyInfo && !pcbChannelInfo) {
    return {}
  }
  let info = {}, designId = "";

  if (rockyInfo && Object.keys(rockyInfo).length && contentType === VERIFICATION) {
    info = rockyInfo.info;
    designId = rockyInfo.designId;
  } else if (pcbChannelInfo && Object.keys(pcbChannelInfo).length) {
    info = pcbChannelInfo && pcbChannelInfo.contentDTO ? pcbChannelInfo.contentDTO : {};
    designId = pcbChannelInfo.designId;
  }


  return { ...info, designId };
}

async function getExtractionPortsInfo(rockyInfo, pcbChannelInfo, contentType, rockyType, projectVersion, multilpleChannelId) {
  const interfaceInfo = getCurrentInterfaceInfo(rockyInfo, pcbChannelInfo, contentType, multilpleChannelId);
  if (contentType === MULTIPLE_CHANNEL && multilpleChannelId) {
    const multiChannelInfo = RockyChannels.get(multilpleChannelId) || {};
    let Port_setups = {}, Signals = {}, ReferenceNets = {}, Ports_generate_setup_list = {};
    for (const verification of multiChannelInfo.children || []) {
      if (verification.name === 'PDN') { continue };
      try {
        const res = await getVerificationContentPromise(verification.id);
        const info = RockySetup.mergeInterfacesInfo(res.interfaces, res.name, rockyType, projectVersion);
        // console.log(info);
        Port_setups[verification.id] = info.Port_setups;
        Signals[verification.id] = info.Signals;
        ReferenceNets[verification.id] = info.ReferenceNets;
        Ports_generate_setup_list[verification.id] = info.Ports_generate_setup_list;
      } catch (error) {
        console.log(error);
      }
    }

    // console.log({
    //   designId: multiChannelInfo.designId,
    //   Port_setups,
    //   Signals,
    //   ReferenceNets,
    //   Ports_generate_setup_list,
    // });

    return {
      designId: multiChannelInfo.designId,
      Port_setups,
      Signals,
      ReferenceNets,
      Ports_generate_setup_list,
    }
  }

  const {
    Port_setups = [],
    Signals = [],
    ReferenceNets = [],
    Ports_generate_setup_list = []
  } = interfaceInfo;

  return {
    Port_setups,
    Signals,
    ReferenceNets,
    Ports_generate_setup_list,
  }
}

function getMultiExtractionPortsInfo({ verificationId, multipleList, Port_setups, Signals, ReferenceNets, Ports_generate_setup_list }) {
  const channel = multipleList.find(item => item.id === verificationId);
  if (!channel) {
    return;
  }
  let port_setups = [], signals = [], referenceNets = [], ports_generate_setup_list = [];
  for (const verification of channel.runInfo.comesFrom) {
    const verificationId = verification.verificationId;
    port_setups = port_setups.concat(Port_setups[verificationId] || []);
    signals = signals.concat(Signals[verificationId] || []);
    referenceNets = referenceNets.concat(ReferenceNets[verificationId] || []);
    ports_generate_setup_list = ports_generate_setup_list.concat(Ports_generate_setup_list[verificationId] || []);
  }
  return {
    verificationId: channel.id,
    port_setups,
    signals,
    referenceNets,
    ports_generate_setup_list
  }
}

function judgeIsSIwaveHFSS(extraction) {
  if (!extraction || !extraction.extractionConfig) {
    return false;
  }

  return extraction.extractionConfig.hybrid;
}

export {
  extractionConversionData,
  extractionReturnData,
  getClipSizeUnit,
  getCurrentInterfaceInfo,
  getExtractionPortsInfo,
  getMultiExtractionPortsInfo,
  judgeIsSIwaveHFSS
}